import digitalData from 'digital-data';
import {
  ATC, INTERACTION, PIP_SUB_CONTENT, NOT_APPLICABLE, STASH
} from '../constants';

export const orderSample = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('order-sample.click', () => {
    const ddoEvent = {
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      category: {
        primaryCategory: INTERACTION
      },
      event: [{
        subContent: {
          section: 'order fabric sample',
          component: NOT_APPLICABLE,
          target: NOT_APPLICABLE
        }
      }]
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('order-sample.atc', ({ output = {} }) => {
    const { skus = [] } = output;

    const item = skus.map((sku) => {
      return {
        displayPosition: NOT_APPLICABLE,
        productInfo: {
          sku
        }
      };
    });

    const ddoEvent = {
      eventInfo: {
        eventName: 'cart addition info'
      },
      category: {
        primaryCategory: STASH
      },

      eventMode: STASH,

      stash: {
        component: 'sample overlay',
        item,
        pageType: 'product',
        section: 'fabric',
        sharedSection: NOT_APPLICABLE,
        target: ATC
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
